// Desenho dela 04/10 (logo "CRM Multimarca" verde-esmeralda): o grafico de
// barras com a seta em ouro velho. Em SVG, e nao o PNG recortado, para ficar nitido
// em qualquer tamanho e sem o fundo do PNG por cima do cabecalho.
export function LogoMarca({ className = 'w-10 h-10' }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="logo-ouro" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#f1dc9c" />
          <stop offset="0.5" stopColor="#cfa951" />
          <stop offset="1" stopColor="#8a6620" />
        </linearGradient>
        <linearGradient id="logo-prata" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#ffffff" />
          <stop offset="1" stopColor="#cbd5e1" />
        </linearGradient>
      </defs>
      {/* arco que abraca as barras e vira a seta */}
      <path d="M30 22 C 12 30, 4 44, 14 52 C 22 57, 40 55, 56 52 C 40 53, 22 54, 16 49 C 10 43, 16 32, 30 22 Z" fill="url(#logo-ouro)" />
      <path d="M17 42 C 30 34, 42 24, 52 13" stroke="url(#logo-ouro)" strokeWidth="3.2" fill="none" strokeLinecap="round" />
      <path d="M45 10 L 58 6 L 55 19 Z" fill="url(#logo-ouro)" />
      <rect x="21" y="38" width="6" height="11" rx="1" fill="url(#logo-ouro)" />
      <rect x="29" y="33" width="6" height="16" rx="1" fill="url(#logo-prata)" />
      <rect x="37" y="28" width="6" height="21" rx="1" fill="url(#logo-prata)" />
      <rect x="45" y="20" width="7" height="29" rx="1" fill="url(#logo-ouro)" />
    </svg>
  )
}
